import {useCallback, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import ActionBar from "~/layout/ActionBar";
import {Loading} from "~/components";
import {
    OrderTable,
    OrderSearchBar
} from "../components";
import {
    orderActions,
    orderErrorSelector,
    orderFilterSelector,
    orderItemsSelector,
    orderLoadingSelector,
    orderPaginationSelector
} from "../../../reduxs/Order/orderSlice";
import {Button, Icon} from "../../../components";

const Order = () =>
{
    const dispatch = useDispatch();

    const items = useSelector(orderItemsSelector);
    const loading = useSelector(orderLoadingSelector);
    const error = useSelector(orderErrorSelector);
    const filter = useSelector(orderFilterSelector);
    const pagination = useSelector(orderPaginationSelector);

    //Events
    const eventHandlers = {
        //Load data
        load: useCallback(() => {
            dispatch(orderActions.fetchData());
        }, [dispatch]),

        //Filter
        filter: useCallback((newFilter) => {
            dispatch(orderActions.setFilter(newFilter));
            dispatch(orderActions.setPagination({page: 1}));
        }, [dispatch]),

        //Pagination
        pagination: useCallback((page) => {
            dispatch(orderActions.setPagination({page}));
        }, [dispatch]),
    }

    //Load data
    useEffect(() =>
    {
        let isMounted = true;
        if (isMounted) eventHandlers.load();
        return () => { isMounted = false };
    }, [filter, pagination.page]);

    return (
        <>
            <ActionBar title="Đơn hàng">
                <Button outline onClick={eventHandlers.load}>{Icon.reload}</Button>
            </ActionBar>
            <div className="container">
                <div className="content p-2">
                    {loading && <Loading/>}
                    <OrderSearchBar
                        filter={filter}
                        onFilterChange={eventHandlers.filter}
                    />
                    <OrderTable
                        items={items}
                        pagination={pagination}
                        onPaginationChange={eventHandlers.pagination}
                    />
                </div>
            </div>
        </>
    );
}

export default Order;
